import { primaryColor } from '../locatorDriftConstants';

export const versionDiffStyles = {
  controlsPaper: {
    p: 2,
  },
  title: {
    mb: 0.5,
  },
  description: {
    mb: 2,
  },
  analyzeButton: {
    bgcolor: primaryColor,
    '&:hover': { bgcolor: '#3d2a70' },
  },
  catalogPaper: {
    p: 2,
  },
  tablePaper: {
    p: 0,
    overflow: 'hidden',
  },
  riskCell: (risk) => ({
    fontWeight: 700,
    color: risk === 'HIGH' ? '#dc2626' : risk === 'MEDIUM' ? '#d97706' : '#6b7280',
  }),
  elementCell: {
    fontFamily: 'monospace',
    fontSize: 12,
    maxWidth: 280,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  reasonCell: {
    maxWidth: 320,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
};

export const versionDiffMetricColors = {
  high: '#dc2626',
  medium: '#d97706',
  low: '#6b7280',
  info: '#2563eb',
};
